import React from 'react';
var SelectLocation = function (props) {
    var name = props.name, _a = props.locations, locations = _a === void 0 ? {} : _a, _b = props.selected, selected = _b === void 0 ? undefined : _b, onChange = props.onChange, defaultLocation = props.defaultLocation;
    var handleChange = function (evt) { return onChange(evt.target.value); };
    return React.createElement("form", { key: "location", className: "location-filter horizontal dense raised nowrap", action: "#" },
        React.createElement("select", { name: name, onChange: handleChange, value: selected },
            React.createElement("option", { value: defaultLocation }, "Alle steder"),
            Object.keys(locations)
                .map(function (key) { return React.createElement("option", { value: key, key: "location-" + key }, locations[key]); })));
};
export default SelectLocation;
